module.exports = "<div class=\"m-size-image m-size-images\" :style=\"{background: 'linear-gradient('+bgColor+','+(bgColorDown&&(bgColorDown!='#000000')?bgColorDown:bgColor)+')'}\" v-lazy:background-image=\"fnjiImage(image)\" :key=\"image\"></div>"


//////////////////
// WEBPACK FOOTER
// /Users/mac/001.code/xbigger-web/xbigger/fnjinew/build-v2/node_modules/text-loader!./product-detail/component/size-image-single.html
// module id = 243
// module chunks = 0